var _excluded = ["className", "primary", "secondary", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
import { getTableItemDescriptionSize } from "../helpers.js";
/* Table item number component */

var PrimaryNumber = styled.div.withConfig({
  componentId: "CL__sc-1qxpyr2-0"
})(["font:var(--body-text-", ");color:var(--text-color);font-weight:600;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"], _ref => {
  var {
    size
  } = _ref;
  return size;
});
var SecondaryNumber = styled.span.withConfig({
  componentId: "CL__sc-1qxpyr2-1"
})(["font:", ";color:var(--text-color-dim);display:block;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"], _ref2 => {
  var {
    size
  } = _ref2;
  return getTableItemDescriptionSize(size);
});
var Number = _ref3 => {
  var {
      className,
      primary,
      secondary,
      size = 'medium'
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className
  }, props), /*#__PURE__*/React.createElement(PrimaryNumber, {
    size: size
  }, primary), secondary && /*#__PURE__*/React.createElement(SecondaryNumber, {
    size: size
  }, secondary));
};
export default Number;